__turbopack_context__.v({
  "backendSelectorWrapper": "BackendSelector-module__KutSrG__backendSelectorWrapper",
  "buttonGroup": "BackendSelector-module__KutSrG__buttonGroup",
  "currentValue": "BackendSelector-module__KutSrG__currentValue",
  "info": "BackendSelector-module__KutSrG__info",
  "infoText": "BackendSelector-module__KutSrG__infoText",
  "inputGroup": "BackendSelector-module__KutSrG__inputGroup",
  "label": "BackendSelector-module__KutSrG__label",
  "originalValue": "BackendSelector-module__KutSrG__originalValue",
  "resetButton": "BackendSelector-module__KutSrG__resetButton",
  "saveButton": "BackendSelector-module__KutSrG__saveButton",
  "title": "BackendSelector-module__KutSrG__title",
  "urlDisplay": "BackendSelector-module__KutSrG__urlDisplay",
  "urlInput": "BackendSelector-module__KutSrG__urlInput",
  "urlRow": "BackendSelector-module__KutSrG__urlRow",
});
